export default [
  {
    path: '/commission_settlement_applications',
    name: 'commission_settlement_applications.index',
    component: require('./index').default,
    meta: {
      title: '佣金提现申请管理',
      navbar: 'el-icon-money',
      permission: 'commission_settlement_applications.read'
    }
  },
  {
    path: '/commission_settlement_applications/:id',
    name: 'commission_settlement_applications.show',
    component: require('./show').default,
    meta: {
      title: '佣金提现申请详情',
      permission: 'commission_settlement_applications.read'
    }
  },
]
